<template>
    <p class="mt-4 text-dark">
        Let us know how you normally drive
    </p>

    <input-select
        class="mt-4"
        :options="roadTypes"
        :modelValue="roadType"
        :error="errors['tyre_details.road_type']"
        @update:modelValue="$emit('update:roadType', $event)"
        placeholder="Road Type"
    ></input-select>

    <input-select
        class="mt-4"
        :options="drivingStyles"
        :modelValue="drivingStyle"
        :error="errors['tyre_details.driving_style']"
        @update:modelValue="$emit('update:drivingStyle', $event)"
        placeholder="Driving Style"
    ></input-select>

    <input-error v-if="errors['tyre_details.driving_style'] || errors['tyre_details.road_type']">
        Please tell us about your driving style
    </input-error>
</template>
<script>
import InputSelect from '@/Components/Forms/Inputs/InputSelect.vue';
import InputError from '@/Components/Forms/Inputs/InputError.vue';
import { usePage } from '@inertiajs/inertia-vue3';

export default {
    components: { InputSelect, InputError },
    props: {
        roadType: String,
        drivingStyle: String,
        errors: Object,
    },
    computed: {
        drivingStyles() {
            return usePage().props.value.config.reviews.driving_styles;
        },
        roadTypes() {
            return usePage().props.value.config.reviews.road_types;
        },
    }
};
</script>


<style lang="scss" scoped>

</style>
